import ContentPage from '@glass/rock/components/ContentPage/ContentPage';

import homePageGetStaticProps from '@glass/shared/modules/content/pages/homePageGetStaticProps';
import createGetStaticPropsWithErrorTracking from '@glass/shared/modules/next/createGetStaticPropsWithErrorTracking';

export const getStaticProps = createGetStaticPropsWithErrorTracking(homePageGetStaticProps);

export default ContentPage;
